import { useEffect, useState } from 'react';
import api from '../../services/api';

// Informa se a empresa do usuário logado tem o histórico do Zpro habilitado e configurado.
// O resultado é compartilhado entre os componentes (uma única chamada) e pode ser invalidado
// depois de salvar a configuração.

let cache: Promise<boolean> | null = null;
const ouvintes = new Set<() => void>();

const buscar = (): Promise<boolean> => {
  if (!cache) {
    cache = api
      .get('/empresas/atual/zpro-status')
      .then((r) => !!r?.data?.data?.habilitado)
      .catch(() => false);
  }
  return cache;
};

export const invalidarZproHabilitado = () => {
  cache = null;
  ouvintes.forEach((fn) => fn());
};

export function useZproHabilitado(): boolean {
  const [habilitado, setHabilitado] = useState(false);

  useEffect(() => {
    let vivo = true;
    const carregar = () => {
      buscar().then((v) => vivo && setHabilitado(v));
    };
    carregar();
    ouvintes.add(carregar);
    return () => {
      vivo = false;
      ouvintes.delete(carregar);
    };
  }, []);

  return habilitado;
}
